<template>
    <div v-bind:class="'col-md-'+validConfig.col">  
        <label>{{ validConfig.holder }}:</label>
        <div class="form-group">
            <div  class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text ">
                        <i v-if="isError.bool" class="far fa-calendar-alt"></i>
                        <i v-else v-on:click="isErrormsg(isError)" class="fa fa-exclamation-triangle text-danger skew-shake-y" style="cursor:pointer"></i>
                    </span>
                </div>
                <input type="date" :min="minDate" :max="todayDate"  :id="validConfig.id" :value="modelValue ?? ''" @input="$emit('updateValue',($event!.target as HTMLInputElement)!.value,validConfig.name)"   class="form-control" v-bind:class="isError.class"  :placeholder="validConfig.holder"> 
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import {  reactive,toRefs,watchEffect, computed} from "vue";
    import validate from '../../../composable/useValidate'
    import messages from '../../../composable/useMessages'
    
    const { longitud } = validate();
    const { validateNotification } = messages();
           
    const props = withDefaults(defineProps<{
        modelValue: string | null,
        validConfig : { value?: string | null, validate: boolean, name: string, message: string, col: number, min: number, max: number, empaty: number, holder: string, id: string } ,
        statusMin: boolean,
        maxDaysOffset?: number// Enable minimum date
    }>(), {
        maxDaysOffset: 0
    })
   
    const emit = defineEmits<{
       (e: 'updateStatus', name: string,status:boolean): void
       (e: 'updateValue', value: string,name:string): void
    }>()

    const { validConfig, modelValue } = toRefs(props);
    
    let isError = reactive({ validate: false, class: "", required: validConfig.value.message, bool: true }  );
    
    const isErrormsg = (dto: object) => { validateNotification(dto); }

    const todayDate = computed(() => {
        const date = new Date()
        date.setDate(date.getDate() - props.maxDaysOffset )
        const yyyy = date.getFullYear()
        const mm = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        return `${yyyy}-${mm}-${dd}`
    });



    const minDate = computed(() => {
        if (props.statusMin) {
            const pastDate = new Date();
            pastDate.setDate(pastDate.getDate() - 7); // 15 días antes de hoy
            const yyyy = pastDate.getFullYear();
            const mm = String(pastDate.getMonth() + 1).padStart(2, '0');
            const dd = String(pastDate.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`; // Formato YYYY-MM-DD
        } else { return ''; }        
    });



    watchEffect(() => {
        isError = longitud(modelValue.value ?? '', validConfig.value.empaty, validConfig.value.min, validConfig.value.max, isError.required);
        if(isError.validate){  
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateValue',  modelValue.value ?? '', validConfig.value.name  );
        }else{       
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateValue',  modelValue.value ?? '', validConfig.value.name);   
        }
    })
</script>